// Display projection of a listing's resolved ship-from trio per
// ADR_LISTING_SHIP_FROM_ADDRESS.md Phase 2 — used by card components that
// still take a free-text `location: string` prop. Once those components are
// refactored to consume the structured trio directly, this helper goes away.

import { getCountryName } from "@/lib/paypal-countries";

type ShipFromTrio = {
  city?: string | null;
  state?: string | null;
  country?: string | null;
} | null | undefined;

export function shipFromCountryDisplay(trio: ShipFromTrio): string {
  const code = trio?.country;
  return code ? getCountryName(code) : "";
}
